import {
  BibliographySearchResultItem,
  BibliographySearchResultItemFromJSON
} from '@/api/models/bibliography/BibliographySearchResultItem'

export interface BibliographySearchResult {
  total: number
  items: BibliographySearchResultItem[]
}

export function BibliographySearchResultFromJSON(
  json: any
): BibliographySearchResult {
  return {
    total: json.total,
    items: json.items.map(BibliographySearchResultItemFromJSON)
  }
}
